<template>
  <!-- 抄表系统-用户管理 -->
  <a-card :bordered="false">
    <a-row>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="12">
              <a-form-item label="用户编码">
                <a-input v-model="query.userCode" placeholder="" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="用户名称">
                <a-input v-model="query.userName" placeholder="" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="手机号/座机号">
                <a-input v-model="query.phoneNumber" placeholder="" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="水表编号">
                <a-input v-model="query.meterNumber" placeholder="" allow-clear />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12">
              <a-form-item label="表册分组">
                <a-select placeholder="请选择" v-model="query.groupId" allow-clear @change="onGroupChange">
                  <a-select-option v-for="item in GroupList" :key="item.id" :value="item.id">
                    {{ item.groupName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="选择表册">
                <a-select
                  v-model="query.meterBookId"
                  placeholder="请选择表册"
                  :loading="meterBooksLoading"
                  allow-clear
                  show-search
                  :filter-option="filterMeterBookOption"
                  :disabled="!query.groupId"
                >
                  <a-select-option v-for="item in filteredMeterBooksList" :key="item.id" :value="String(item.id)">
                    {{ item.bookName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="水表类型">
                <a-select placeholder="请选择" v-model="query.meterType" allow-clear>
                  <a-select-option :value="1">机械表</a-select-option>
                  <a-select-option :value="2">远传表</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="用水性质">
                <a-select placeholder="请选择" v-model="query.waterUsageType" allow-clear>
                  <a-select-option :value="1">居民用水</a-select-option>
                  <a-select-option :value="2">非居民用水</a-select-option>
                  <a-select-option :value="3">特种用水</a-select-option>
                  <a-select-option :value="4">工业用水</a-select-option>
                  <a-select-option :value="5">混合用水</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="14" :sm="28">
              <a-form-item>
                <a-button type="primary" @click="searchList">查询</a-button>
                <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
                <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateHandle()" v-action:add
                  >新增</a-button
                >
                <a-button
                  type="danger"
                  style="margin-left: 12px"
                  @click="deleteSelectRow()"
                  :loading="deleteCheckLoading"
                  v-action:del
                  >删除</a-button
                >
                <a-button type="primary" style="margin-left: 12px" @click="downloadTemplate()">下载模板</a-button>
                <a-button
                  type="primary"
                  style="margin-left: 12px"
                  @click="exportHandle()"
                  v-action:export
                  :loading="exportLoading"
                >
                  {{ selectedRows && selectedRows.length > 0 ? `导出选中(${selectedRows.length})` : '导出' }}
                </a-button>
                <a-button
                  v-if="selectedRows && selectedRows.length > 0"
                  type="default"
                  style="margin-left: 8px"
                  @click="clearSelection"
                >
                  清除选择
                </a-button>
                <a-upload
                  :file-list="importFileList"
                  :remove="handleImportRemove"
                  :show-upload-list="true"
                  accept=".xlsx,.xls"
                  :multiple="false"
                  :customRequest="customImportRequest"
                >
                  <a-button type="primary" style="margin-left: 12px" :loading="importLoading" v-action:import>
                    <a-icon type="upload" />批量导入
                  </a-button>
                </a-upload>
                <div style="margin-top: 8px; color: #666; font-size: 12px">
                  <a-icon type="info-circle" />
                  提示：勾选数据后点击导出按钮可导出选中数据，未勾选时导出所有数据；点击下载模板获取导入模板，然后使用批量导入功能
                </div>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-row>
        <a-table
          ref="table"
          rowKey="id"
          style="width: 100%; margin-top: 20px"
          bordered
          :columns="columns"
          :scroll="{ x: 2000 }"
          :data-source="list"
          :pagination="pagination"
          :rowSelection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
          :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
          @change="pageChange"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="addOrUpdateHandle(record)" style="padding-right: 15px" v-action:edit> 编辑 </a>
            <a @click="details(record.id)"> 用水详情 </a>
          </span>
        </a-table>
      </a-row>
      <!-- 新增 -->
      <a-modal
        :title="isUpdate ? '编辑' : '新增'"
        style="top: 20px"
        :width="800"
        v-model="addOrUpdateVisible"
        @ok="handleOk"
      >
        <div class="form-container">
          <div class="form-columns">
            <div class="form-column">
              <a-form :form="addOrUpdateForm">
                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }" label="用户编码">
                  <a-input v-decorator="['userCode', { rules: [{ required: true, message: '请输入用户编码' }] }]" />
                </a-form-item>
                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }" label="用户名称">
                  <a-input v-decorator="['userName', { rules: [{ required: true, message: '请输入用户名称' }] }]" />
                </a-form-item>
                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }" label="用户地址">
                  <a-input v-decorator="['userAddress', { rules: [{ required: true, message: '请输入用户地址' }] }]" />
                </a-form-item>
                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }" label="手机号/座机号">
                  <a-input
                    v-decorator="[
                      'phoneNumber',
                      {
                        rules: [
                          { required: false, message: '请输入手机号//座机号' },
                          {
                            pattern: /^\d+$/,
                            message: '请输入正确的号码!'
                          }
                        ]
                      }
                    ]"
                  />
                </a-form-item>
                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }" label="用户类型">
                  <a-select
                    placeholder="请选择"
                    allow-clear
                    v-decorator="['userType', { rules: [{ required: false, message: '请选择用户类型' }] }]"
                  >
                    <a-select-option value="1">普通用户</a-select-option>
                    <a-select-option value="2">用水大户</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="表册分组：" required :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
                  <a-select
                    v-decorator="['groupId', { rules: [{ required: true, message: '请选择表册分组' }] }]"
                    @change="onFormGroupChange"
                  >
                    <a-select-option v-for="item in GroupList" :key="item.id" :value="item.id">
                      {{ item.groupName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }" label="表册选择">
                  <a-select
                    v-decorator="['meterBookId', { rules: [{ required: true, message: '请选择表册' }] }]"
                    placeholder="请选择表册"
                    :loading="meterBooksLoading"
                    allow-clear
                    :disabled="!formGroupId"
                  >
                    <a-select-option v-for="item in filteredFormMeterBooksList" :key="item.id" :value="String(item.id)">
                      {{ item.bookName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-form>
            </div>

            <div class="form-column">
              <a-form :form="addOrUpdateForm">
                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }" label="水表编号">
                  <a-input v-decorator="['meterNumber', { rules: [{ required: false, message: '水表编号' }] }]" />
                </a-form-item>
                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }" label="水表状态">
                  <a-select
                    v-decorator="[
                      'meterStatus',
                      { rules: [{ required: true, message: '请输入水表状态' }], initialValue: '1' }
                    ]"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  >
                    <a-select-option value="1">正常</a-select-option>
                    <a-select-option value="2">异常</a-select-option>
                    <a-select-option value="3">取表</a-select-option>
                    <a-select-option value="4">关闸</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }" label="口径">
                  <a-input v-decorator="['caliber']" placeholder="请输入口径(如DN15)" />
                </a-form-item>
                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }" label="品牌">
                  <a-input v-decorator="['brand']" />
                </a-form-item>
                <a-form-item label="水表类型" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
                  <a-select
                    v-decorator="[
                      'meterType',
                      { rules: [{ required: true, message: '请选择类型' }], initialValue: '1' }
                    ]"
                  >
                    <a-select-option value="1">机械表</a-select-option>
                    <a-select-option value="2">远传表</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }" label="安装日期">
                  <a-date-picker
                    placeholder="安装日期"
                    :allowClear="false"
                    style="width: 100%"
                    format="YYYY-MM-DD"
                    valueFormat="YYYY-MM-DD"
                    v-decorator="['installationDate']"
                  />
                </a-form-item>
                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }" label="用水性质">
                  <a-select
                    allow-clear
                    v-decorator="['waterUsageType', { rules: [{ required: false, message: '请选择用水性质' }] }]"
                    @change="onWaterUsageTypeChange"
                  >
                    <a-select-option :value="1">居民用水</a-select-option>
                    <a-select-option :value="2">非居民用水</a-select-option>
                    <a-select-option :value="3">特种用水</a-select-option>
                    <a-select-option :value="4">工业用水</a-select-option>
                    <a-select-option :value="5">混合用水</a-select-option>
                  </a-select>
                </a-form-item>
              </a-form>
            </div>
          </div>
          <div class="form-full-width" v-show="currentWaterUsageType === 5">
            <a-form :form="addOrUpdateForm">
              <a-form-item :labelCol="{ span: 3 }" :wrapperCol="{ span: 24 }" label="混合用水备注:">
                <a-textarea
                  v-decorator="['mixedUsageRemark', { rules: [{ required: false }] }]"
                  :rows="4"
                  placeholder="请输入混合用水备注信息"
                />
              </a-form-item>
            </a-form>
          </div>
        </div>
      </a-modal>
    </a-row>
    <a-modal
      title="导入提示"
      :visible="importResultVisible"
      :footer="null"
      @cancel="importResultVisible = false"
      :width="400"
    >
      <div style="text-align: center">
        <div style="margin-bottom: 12px">
          共导入 <span style="color: #333; font-weight: bold">{{ importResult.total }}</span> 条数据， 已导入
          <span style="color: green; font-weight: bold">{{ importResult.success }}</span> 条， 失败
          <span style="color: red; font-weight: bold">{{ importResult.fail }}</span> 条！
        </div>
        <div v-if="importResult.fail > 0" style="margin-bottom: 16px">错误数据已自动下载到本地，请修改后重新上传！</div>
        <a-button
          v-if="importResult.fail > 0 && importResult.userCode && importResult.userCode.length > 0"
          type="primary"
          style="margin-bottom: 16px"
          @click="downloadImportErrorFile(importResult.userCode)"
          >重新下载</a-button
        >
        <div style="margin-top: 8px">
          <a-button style="margin-right: 8px" @click="importResultVisible = false">确定</a-button>
        </div>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import axios from 'axios'
// import storage from 'store'
// import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'UserMeter',
  mixins: [mixinViewModule],
  data() {
    return {
      importResultVisible: false,
      importResult: {
        total: 0,
        success: 0,
        fail: 0,
        downloadUrl: ''
      },
      exportFileName: '用户管理数据.xlsx', //导出文件名
      downloadTemplateUrl: 'meter-manager/users/stencil', // 水表模板下载URL
      downloadTemplateName: '用户管理导入模板.xlsx', // 模板文件名
      importUrl: 'meter-manager/users/import', // 批量导入URL
      addOrUpdateUrl: '/meter-manager/users/save', // 新增或更新数据url
      queryUrl: '/meter-manager/users/page', // 分页
      deleteUrl: '/meter-manager/users/batch', // 删除数据url
      deleteCheckUrl: '/meter-manager/users/deleteCheck/batch', // 删除检查接口url
      needQuery: true,
      recycleBinVisible: false,
      visibles: false,
      confirmLoading: false,
      deleteCheckLoading: false, // 删除检查加载状态
      fileList: [],
      importFileList: [], // 导入文件列表
      importLoading: false,
      selectedRowKeys: [],
      selectedRows: [],
      meterBooksList: [], // 表册列表
      meterBooksLoading: false, // 表册加载状态
      allMeterBooksList: [], // 所有表册列表（用于过滤）
      detailsdata: [], // 查看详情
      title: '',
      query: {
        userCode: '',
        brand: '',
        caliber: '',
        groupId: '',
        installationDate: '',
        limit: '',
        meterBookId: '',
        meterNumber: '',
        meterStatus: '',
        meterType: '',
        orderType: '',
        page: '',
        phoneNumber: '',
        sortOrder: '',
        tenantId: '',
        useruserAddress: '',
        userName: '',
        userType: '',
        waterUsageType: ''
      },
      isDetailMode: false,

      list: [],
      columns: [
        { id: 0, title: '用户编码', dataIndex: 'userCode', key: 'userCode' },
        { id: 1, title: '用户名称', dataIndex: 'userName', key: 'userName' },
        { id: 2, title: '水表编号', dataIndex: 'meterNumber', key: 'meterNumber' },
        { id: 3, title: '用户地址', dataIndex: 'userAddress', ellipsis: true, width: 220, key: 'userAddress' },
        {
          id: 4,
          title: '用水性质',
          dataIndex: 'waterUsageType',
          key: 'waterUsageType',
          customRender: (text) => this.getWaterUsage(text)
        },
        { id: 5, title: '手机号码', dataIndex: 'phoneNumber', key: 'phoneNumber' },
        { id: 6, title: '安装日期', dataIndex: 'installationDate', key: 'installationDate' },
        { id: 7, title: '口径', dataIndex: 'caliber', key: 'caliber' },
        { id: 8, title: '品牌', dataIndex: 'brand', key: 'brand' },
        {
          id: 9,
          title: '水表类型',
          dataIndex: 'meterType',
          key: 'meterType',
          customRender: (text) => this.getMeterType(text)
        },
        {
          id: 10,
          title: '水表状态',
          dataIndex: 'meterStatus',
          key: 'meterStatus',
          customRender: (text) => this.getMeterStatus(text)
        },
        {
          id: 11,
          title: '表册分组',
          dataIndex: 'groupId',
          key: 'groupId',
          customRender: (text) => this.getGroupName(text)
        },
        {
          id: 12,
          title: '所在表册',
          dataIndex: 'meterBookId',
          key: 'meterBookId',
          customRender: (text) => this.getMeterBookName(text)
        },
        {
          id: 13,
          title: '操作',
          align: 'center',
          key: 'action',
          dataIndex: 'action',
          width: 150,
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 1,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      selectedKeys: [],

      groupListUrl: '/meter-manager/meter_book_groups/list',
      meterBooksUrl: '/meter-manager/meterBooks/list',
      GroupList: [],
      formGroupId: '', // 表单中当前选中的分组ID
      currentWaterUsageType: null // 当前选中的用水性质
    }
  },
  computed: {
    // 根据当前选中的分组ID过滤表册列表
    filteredMeterBooksList() {
      if (!this.query.groupId) {
        return []
      }
      return this.allMeterBooksList.filter((item) => {
        // 支持多种可能的字段名
        const itemGroupId = item.groupId || item.group_id || item.meterBookGroupId || item.meter_book_group_id
        // 确保类型匹配，都转换为字符串进行比较
        return String(itemGroupId) === String(this.query.groupId)
      })
    },
    // 根据表单中选中的分组ID过滤表册列表
    filteredFormMeterBooksList() {
      if (!this.formGroupId) {
        return []
      }
      return this.allMeterBooksList.filter((item) => {
        // 支持多种可能的字段名
        const itemGroupId = item.groupId || item.group_id || item.meterBookGroupId || item.meter_book_group_id
        // 确保类型匹配，都转换为字符串进行比较
        return String(itemGroupId) === String(this.formGroupId)
      })
    },
    // 获取当前选中表册的名称
    selectedMeterBookName() {
      return this.getMeterBookName(this.query.meterBookId)
    }
  },
  mounted() {
    // this.initDictionaries();
  },
  created() {
    // 设置系统名称
    this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}抄表系统`)

    this.getGroupList()
    this.getMeterBooksList()
    this.queryList()
  },
  methods: {
    // 获取分组列表
    async getGroupList() {
      try {
        const response = await this.$http.get(this.groupListUrl)
        this.GroupList = response.data
      } catch (error) {
        console.error('获取分组列表失败:', error)
      }
    },

    // 水表状态转换
    getMeterStatus(status) {
      const statusMap = {
        1: '正常',
        2: '异常',
        3: '取表',
        4: '关闸'
      }
      return statusMap[status] || '未知状态'
    },
    // 水表类型转换
    getMeterType(type) {
      const typeMap = {
        1: '机械表',
        2: '远传表'
      }
      return typeMap[type] || '未知类型'
    },
    // 用水性质转换
    getWaterUsage(usage) {
      const usageMap = {
        1: '居民用水',
        2: '非居民用水',
        3: '特种用水',
        4: '工业用水',
        5: '混合用水'
      }
      return usageMap[usage] || '未知性质'
    },
    // 用户类型转换
    getUserType(type) {
      const typeMap = {
        1: '普通用户',
        2: '用水大户'
      }
      return typeMap[type] || '未知类型'
    },
    //获取列表
    queryList() {
      // 查询前如果没有current，默认第一页
      if (!this.pagination.current) this.pagination.current = 1
      if (!this.pagination.pageSize) this.pagination.pageSize = 10
      const params = {
        orderType: this.orderType,
        ...this.query,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .post(this.queryUrl, params)
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.selectedRows = []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            if (data.total > 0) {
              this.isadd = false
              // 如果当前页没有数据且不是第一页，自动跳转到第一页
              if (this.list.length === 0 && this.pagination.current > 1) {
                this.pagination.current = 1
                this.queryList()
                return
              }
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },

    // 搜索查询（重置到第一页）
    searchList() {
      this.pagination.current = 1 // 搜索时重置到第一页
      this.queryList()
    },
    //新增或编辑
    addOrUpdateHandle(data) {
      this.isUpdate = false
      this.addOrUpdateForm.resetFields()
      this.formGroupId = '' // 重置表单分组ID
      this.currentWaterUsageType = null // 重置用水性质
      //编辑
      if (data) {
        console.log('data', data)
        this.currentId = data.id
        this.isUpdate = true
        this.$nextTick(() => {
          this.addOrUpdateForm.setFieldsValue({
            userCode: data.userCode,
            meterNumber: data.meterNumber,
            userName: data.userName,
            meterStatus: data.meterStatus ? String(data.meterStatus) : undefined,
            userAddress: data.userAddress,
            caliber: data.caliber,
            phoneNumber: data.phoneNumber,
            brand: data.brand,
            userType: data.userType ? String(data.userType) : undefined,
            meterType: data.meterType ? String(data.meterType) : undefined,
            groupId: data.groupId,
            installationDate: data.installationDate,
            meterBookId: data.meterBookId ? String(data.meterBookId) : undefined,
            waterUsageType: data.waterUsageType ? Number(data.waterUsageType) : undefined,
            mixedUsageRemark: data.mixedUsageRemark
          })
          this.formGroupId = data.groupId // 设置表单分组ID
          this.currentWaterUsageType = Number(data.waterUsageType) // 设置当前用水性质
        })
      } else {
        //新增时设置默认值
        this.$nextTick(() => {
          this.addOrUpdateForm.setFieldsValue({
            meterStatus: '1',
            userType: undefined,
            meterType: '1'
          })
        })
      }
      this.addOrUpdateVisible = true
    },
    //新增
    handleOk() {
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          console.log(JSON.stringify(values))
          let data
          const header = {
            'Content-Type': 'application/json',
            Authorization: this.token
          }
          let method
          let message
          if (this.isUpdate == false) {
            method = 'post'
            message = '新增成功'
            data = {
              userCode: values.userCode,
              meterNumber: values.meterNumber,
              userName: values.userName,
              meterStatus: values.meterStatus,
              userAddress: values.userAddress,
              caliber: values.caliber,
              phoneNumber: values.phoneNumber,
              brand: values.brand,
              userType: values.userType,
              meterType: values.meterType,
              groupId: values.groupId,
              installationDate: values.installationDate,
              meterBookId: values.meterBookId,
              waterUsageType: values.waterUsageType
            }
            if (values.waterUsageType === 5 && values.mixedUsageRemark) {
              data.mixedUsageRemark = values.mixedUsageRemark
            }
          } else {
            method = 'put'
            message = '修改成功'
            data = {
              id: this.currentId,
              userCode: values.userCode,
              meterNumber: values.meterNumber,
              userName: values.userName,
              meterStatus: values.meterStatus,
              userAddress: values.userAddress,
              caliber: values.caliber,
              phoneNumber: values.phoneNumber,
              brand: values.brand,
              userType: values.userType,
              meterType: values.meterType,
              groupId: values.groupId,
              installationDate: values.installationDate,
              meterBookId: values.meterBookId,
              waterUsageType: values.waterUsageType
            }
            if (values.waterUsageType === 5 && values.mixedUsageRemark) {
              data.mixedUsageRemark = values.mixedUsageRemark
            }
          }
          this.$http({
            url: this.addOrUpdateUrl,
            data: data,
            method: method,
            headers: header
          }).then((resolve) => {
            console.log(resolve)
            if (resolve.code === 0) {
              console.log(resolve)
              this.$message.success('操作成功！')
              this.addOrUpdateVisible = false
              this.queryList()
              this.currentId = ''
            } else {
              this.$message.error(resolve.message)
            }
          })
        }
      })
    },
    // 查看详情
    details(id) {
      const user = this.list.find((item) => String(item.id) === String(id) || String(item.userId) === String(id))
      if (user) {
        const query = {
          // userId: user.userId || user.id,
          userCode: user.userCode,
          userName: user.userName
        }
        // 构造query字符串
        const params = Object.entries(query)
          .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
          .join('&')
        const url = `${window.location.origin}/dataAnalysis?${params}`
        window.open(url, '_blank')
      }
    },
    handleCancelk() {
      this.visibles = false
    },
    // 删除
    deleteSelectRow() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning('请选择要删除的记录')
        return
      }

      // 先调用删除检查接口
      this.checkBeforeDelete()
    },

    // 删除前检查
    async checkBeforeDelete() {
      this.deleteCheckLoading = true

      try {
        const { data, code, message } = await this.$http.post(this.deleteCheckUrl, this.selectedRows)

        // 根据检查结果显示不同的提示信息
        let confirmContent = '确定要删除选中的记录吗？'
        let confirmTitle = '删除确认'
        let okType = 'danger'
        console.log(data)

        if (code === 0 && data) {
          // 检查成功，根据返回的数据判断
          if (data.taskDetailCount !== '0') {
            // 有警告但可以删除的情况
            confirmTitle = '删除警告'
            confirmContent = '所选用户有' + data.taskDetailCount + '个抄表任务,' + '\n\n确定要继续删除吗？'
            okType = 'danger'
          }
        } else if (message) {
          // 接口返回了错误信息
          confirmTitle = '删除提醒'
          confirmContent = message + '\n\n确定要继续删除吗？'
        }

        // 显示确认对话框
        this.$confirm({
          title: confirmTitle,
          content: confirmContent,
          okText: '确定删除',
          cancelText: '取消',
          okType: okType,
          onOk: () => {
            this.performDelete()
          }
        })
      } catch (error) {
        console.error('删除检查失败:', error)

        // 如果检查接口失败，仍然允许删除，但给出提示
        this.$confirm({
          title: '删除确认',
          content: '无法获取删除检查信息，可能存在网络问题。\n\n确定要删除选中的记录吗？',
          okText: '确定删除',
          cancelText: '取消',
          okType: 'danger',
          onOk: () => {
            this.performDelete()
          }
        })
      } finally {
        this.deleteCheckLoading = false
      }
    },

    // 执行删除操作
    performDelete() {
      this.$http
        .delete(`${this.deleteUrl}`, { data: this.selectedRows })
        .then(({ code }) => {
          if (code === 0) {
            this.$message.success('删除成功')
            this.selectedRows = []
            this.queryList()
          }
        })
        .catch((error) => {
          console.error('删除失败:', error)
          this.$message.error('删除失败，请稍后重试')
        })
    },
    //下载模版
    downloadTemplate(params = {}) {
      const token = this.$store.getters.token
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.downloadTemplateUrl}`
      axios
        .get(url, {
          params: params,
          headers: {
            Authorization: token
          },
          responseType: 'blob' // 重要：设置响应类型为blob
        })
        .then((res) => {
          // 检查响应状态
          if (res.status !== 200) {
            throw new Error('模板下载失败')
          }

          // 检查响应头中的文件名
          const contentDisposition = res.headers['content-disposition']
          let fileName = this.downloadTemplateName || '导入模板.xlsx'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = decodeURIComponent(fileNameMatch[1].replace(/['"]/g, ''))
            }
          }

          // 创建blob对象
          const blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

          // 创建下载链接
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)

          this.$message.success('模板下载成功')
        })
        .catch((error) => {
          console.error('模板下载失败:', error)

          // 如果是blob错误，尝试解析错误信息
          if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader()
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result)
                this.$message.error(errorData.message || '模板下载失败')
              } catch (e) {
                this.$message.error('模板下载失败')
              }
            }
            reader.readAsText(error.response.data)
          } else {
            this.$message.error('模板下载失败')
          }
        })
    },
    // 批量导入相关方法
    customImportRequest({ file, onSuccess, onError }) {
      // 校验
      const isExcel =
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'application/vnd.ms-excel' ||
        file.name.endsWith('.xlsx') ||
        file.name.endsWith('.xls')
      if (!isExcel) {
        this.$message.error('只能上传 Excel 文件!')
        onError && onError('文件类型错误')
        return
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB!')
        onError && onError('文件过大')
        return
      }
      this.importFileList = [file]
      this.handleImportUpload(file, onSuccess, onError)
    },
    handleImportUpload(file, onSuccess, onError) {
      this.importLoading = true
      const formData = new FormData()
      formData.append('file', file)
      this.$http({
        method: 'post',
        url: this.importUrl,
        headers: {
          Authorization: this.$store.getters.token
        },
        data: formData
      })
        .then((response) => {
          // 新接口返回结构处理
          const res = response
          if (res && res.code === 0 && res.data) {
            const { error, insert, all, userCode } = res.data
            this.importResult = {
              total: all,
              success: insert,
              fail: error,
              userCode: userCode || []
            }
            this.importResultVisible = true
            this.importFileList = []
            this.queryList()
            this.selectedRows = []
            // 有错误时自动下载错误文件
            if (error > 0 && userCode && userCode.length > 0) {
              this.downloadImportErrorFile(userCode)
            }
            // this.$message.success(res.message || '导入完成')
            onSuccess && onSuccess()
          } else {
            this.$message.error(res.message || '导入失败')
            onError && onError(res.message)
          }
          this.importLoading = false
        })
        .catch((error) => {
          this.$message.error('导入失败，请检查文件格式或网络连接')
          this.importLoading = false
          onError && onError(error)
        })
    },
    // 导出错误数据文件
    downloadImportErrorFile(userCodes) {
      const token = this.$store.getters.token
      const url = `${process.env.VUE_APP_API_BASE_URL}meter-manager/users/exportError`
      this.exportLoading = true
      axios({
        method: 'post',
        url: url,
        data: userCodes,
        responseType: 'blob', // 重要：设置响应类型为blob
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        }
      })
        .then((res) => {
          // 检查响应状态
          if (res.status !== 200) {
            throw new Error('下载错误数据失败')
          }

          // 检查响应头中的文件名
          const contentDisposition = res.headers['content-disposition']
          let fileName = '导入错误数据.xlsx'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = decodeURIComponent(fileNameMatch[1].replace(/['"]/g, ''))
            }
          }

          // 创建blob对象
          const blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

          // 创建下载链接
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)

          // this.$message.success('错误数据已下载')
          this.exportLoading = false
        })
        .catch((error) => {
          console.error('下载错误数据失败:', error)

          // 如果是blob错误，尝试解析错误信息
          if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader()
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result)
                this.$message.error(errorData.message || '下载错误数据失败')
              } catch (e) {
                this.$message.error('下载错误数据失败')
              }
            }
            reader.readAsText(error.response.data)
          } else {
            this.$message.error('下载错误数据失败')
          }

          this.exportLoading = false
        })
    },
    //导出
    exportHandle() {
      // 检查是否有选中的行
      if (this.selectedRows && this.selectedRows.length > 0) {
        // 如果有选中项，使用选中ID导出
        this.exportHandleIdList()
      } else {
        // 如果没有选中项，导出所有数据
        this.exportAllData()
      }
    },

    // 导出所有数据
    exportAllData() {
      this.exportLoading = true
      const token = this.$store.getters.token

      // 构建查询参数
      const queryParams = { ...this.query }
      Object.keys(queryParams).forEach((key) => {
        if (queryParams[key] === '' || queryParams[key] === null || queryParams[key] === undefined) {
          delete queryParams[key]
        }
      })

      const url = `${process.env.VUE_APP_API_BASE_URL}meter-manager/users/allExport`
      axios
        .get(url, {
          params: queryParams,
          headers: {
            Authorization: token
          },
          responseType: 'blob' // 重要：设置响应类型为blob
        })
        .then((res) => {
          // 检查响应状态
          if (res.status !== 200) {
            throw new Error('导出失败')
          }

          // 检查响应头中的文件名
          const contentDisposition = res.headers['content-disposition']
          let fileName = this.exportFileName || '导出数据.xlsx'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = decodeURIComponent(fileNameMatch[1].replace(/['"]/g, ''))
            }
          }

          // 创建blob对象
          const blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

          // 创建下载链接
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)

          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch((error) => {
          console.error('导出失败:', error)

          // 如果是blob错误，尝试解析错误信息
          if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader()
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result)
                this.$message.error(errorData.message || '导出失败')
              } catch (e) {
                this.$message.error('导出失败')
              }
            }
            reader.readAsText(error.response.data)
          } else {
            this.$message.error('导出失败')
          }

          this.exportLoading = false
        })
    },
    // id导出
    exportHandleIdList() {
      this.exportLoading = true
      const token = this.$store.getters.token

      const url = `${process.env.VUE_APP_API_BASE_URL}meter-manager/users/export`
      axios
        .post(url, this.selectedRows, {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json'
          },
          responseType: 'blob' // 重要：设置响应类型为blob
        })
        .then((res) => {
          // 检查响应状态
          if (res.status !== 200) {
            throw new Error('导出失败')
          }

          // 检查响应头中的文件名
          const contentDisposition = res.headers['content-disposition']
          let fileName = this.exportFileName || '导出数据.xlsx'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = decodeURIComponent(fileNameMatch[1].replace(/['"]/g, ''))
            }
          }

          // 创建blob对象
          const blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

          // 创建下载链接
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)

          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch((error) => {
          console.error('导出失败:', error)

          // 如果是blob错误，尝试解析错误信息
          if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader()
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result)
                this.$message.error(errorData.message || '导出失败')
              } catch (e) {
                this.$message.error('导出失败')
              }
            }
            reader.readAsText(error.response.data)
          } else {
            this.$message.error('导出失败')
          }

          this.exportLoading = false
        })
    },

    // 获取表册列表
    getMeterBooksList() {
      this.meterBooksLoading = true
      this.$http
        .get(this.meterBooksUrl)
        .then(({ data }) => {
          // 确保返回的数据是数组格式
          this.allMeterBooksList = Array.isArray(data) ? data : data.list || data.data || []
          this.meterBooksLoading = false
        })
        .catch((error) => {
          console.error('获取表册列表失败:', error)
          this.meterBooksLoading = false
          this.$message.error('获取表册列表失败')
          this.allMeterBooksList = []
        })
    },

    // 获取表册名称
    getMeterBookName(meterBookId) {
      if (!meterBookId || !this.allMeterBooksList) return '-'
      const meterBook = this.allMeterBooksList.find((item) => String(item.id) === String(meterBookId))
      return meterBook ? meterBook.bookName : '-'
    },

    // 获取分组名称
    getGroupName(groupId) {
      if (!groupId || !this.GroupList) return '-'
      const group = this.GroupList.find((item) => String(item.id) === String(groupId))
      return group ? group.groupName : '-'
    },

    // 表册搜索过滤函数
    filterMeterBookOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    // 重置查询条件
    resetList() {
      this.query = {
        userCode: '',
        brand: '',
        caliber: '',
        groupId: '',
        installationDate: '',
        limit: '',
        meterBookId: '',
        meterNumber: '',
        meterStatus: '',
        meterType: '',
        orderType: '',
        page: '',
        phoneNumber: '',
        sortOrder: '',
        tenantId: '',
        useruserAddress: '',
        userName: '',
        userType: '',
        waterUsageType: ''
      }
      this.pagination.current = 1 // 重置到第一页
      this.selectedRows = [] // 清空选择的行
      this.queryList()
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRows = selectedRowKeys
    },
    pageChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.queryList()
      // 翻页时清空选择的行
      this.selectedRows = []
    },
    // 分组变化时的处理
    onGroupChange(value) {
      this.query.meterBookId = '' // 清空表册选择
      this.pagination.current = 1 // 重置到第一页
    },
    // 表单中分组变化时的处理
    onFormGroupChange(value) {
      this.formGroupId = value
      this.addOrUpdateForm.setFieldsValue({
        meterBookId: undefined // 清空表册选择
      })
    },

    // 用水性质变化时的处理
    onWaterUsageTypeChange(value) {
      this.currentWaterUsageType = value
    },

    // 清除选择
    clearSelection() {
      this.selectedRows = []
      this.$message.success('已清除选择')
    },

    handleImportRemove(file) {
      const index = this.importFileList.indexOf(file)
      if (index > -1) {
        this.importFileList.splice(index, 1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.ant-form-item-label {
  width: 90px;
}

/deep/.ant-col-4 {
  width: 24.666667%;
}

.ant-table-wrapper {
  width: 81%;
}

.detail {
  margin: 10px 0;
}

/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}

.form-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

.form-columns {
  display: flex;
  gap: 32px;
}

.form-column {
  flex: 1;
}

.form-column .ant-form-item-label {
  text-align: right;
  padding-right: 12px;
}

.form-full-width {
  padding-left: 30px;
}
</style>
